import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function apiCall(menuPlannerIds: string[]): Promise<Optional<ResponseData>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/MenuPlanner/api/backend/MenuPlanner/items-bulk`;
	return axios
		.post(url, {
			menuPlannerIds,
		})
		.toOptionalMapped((x) => x.data);
}

export type ResponseData = MenuPlannerItemsBulkResponse[];

export type MenuPlannerItemsBulkResponse = {
	menuplanId: string;
	lastEditedDate: string | null;
	lastEditedBy: string;
	location: string;
	costCenter: string;
	items: MenuPlannerItem[];
};

export type MenuPlannerItem = {
	id: string;
	quantity: number;
	titleTranslations: Translation;
	type: string;
	date: string;
};

export type Translation = {
	[key: string]: string;
};
